import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchTeamOptions = createAsyncThunk(
  'options/fetchTeamOptions',
  async (_, { signal, rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/api/teamOptions`, { signal });
      return Array.isArray(res.data) ? res.data : [];
    } catch (e) {
      // If the thunk was aborted (navigation/unmount), let RTK mark it as aborted.
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      return rejectWithValue(e?.message || 'Failed to fetch team options');
    }
  }
);

const initialState = {
  teamOptions: [],
  teamOptionsLoading: false,
  teamOptionsError: null,
};

const optionsSlice = createSlice({
  name: 'options',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeamOptions.pending, (state) => {
        state.teamOptionsLoading = true;
        state.teamOptionsError = null;
      })
      .addCase(fetchTeamOptions.fulfilled, (state, action) => {
        state.teamOptionsLoading = false;
        state.teamOptions = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchTeamOptions.rejected, (state, action) => {
        state.teamOptionsLoading = false;
        if (action?.meta?.aborted) return;
        state.teamOptionsError = action.payload || action.error?.message || 'Failed to fetch team options';
      });
  },
});

export default optionsSlice.reducer;


